/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.directives {

    export interface IExpressionGroupScope extends ng.IScope {
        model: ExpressionGroupModel;
    }

    export class ExpressionGroup implements IDirective {
        public templateUrl = './app/views/directives/expressionGroup.html';
        public restrict: string = 'E';
        public controller = ['$scope', '$compile', 'conditionService', ExpressionGroupController];
        public controllerAs = 'controller';
        public scope: any = {
            group: "=",
            isReadonly: "=",
            processConfigurationId:"="
        };

        public link($scope: IExpressionGroupScope, element: JQuery, attrs: ng.IAttributes, controller: ExpressionGroupController) {
            controller.setElement(element);
        }
    }

    export class ExpressionGroupModel {
        public group: Wars.Domain.Model.Conditions.GroupExpression;

        constructor(
            private conditionService: services.ConditionService,
            private $compile: angular.ICompileService,
            private $scope,
            public isReadonly) {
            // Empty Constructor    
        }

        public setGroup(group: Wars.Domain.Model.Conditions.GroupExpression, element: JQuery) {
            this.group = group;

            var template = '<inner-expression-group expression="expression" process-configuration-id="processConfigurationId" is-readonly="model.isReadonly" ng-repeat="expression in model.group.children"></inner-expression-formSection>';
            var htmlToAppend = this.$compile(template)(this.$scope);
            var appendElement = element.find("div[data-append]");
            appendElement.empty();
            //TODO: somehow find scope of inner-expression-group element and destroy to cleanup compilings - e.g. scope.$destroy();
            appendElement.append(htmlToAppend);

            if (group) {
                group.entityAspect.loadNavigationProperty("children");
            }
        }

        public removePart(expression) {
            this.group.children.remove(expression);
        }

        private checkGroup() {

        }

        public addGroupExpression() {
            this.checkGroup();
            var newGroup = this.conditionService.createGroupExpression();
            this.group.children.push(newGroup);
        }

        private addGroup(newGroup: Wars.Domain.Model.Conditions.GroupExpression) {
            var element = document.createElement('inner-expression-group');
            element.setAttribute("expression", "expression");
            element.setAttribute("ng-repeat", "expression in model.group.children");
            var expressionGroup = angular.element(element);
            var el = this.$compile(expressionGroup)(this.$scope);

            var appendElement = document.getElementById(String(this.group.id));
            angular.element(appendElement).append(expressionGroup);
        }

        public addTreeItemToTreeItemExpression() {
            this.checkGroup();
            this.group.children.push(this.conditionService.createFieldExpression());
        }

        public addStepExpression() {
            this.checkGroup();
            this.group.children.push(this.conditionService.createStepExpression());
        }

        public addTreeItemToConstantExpression() {
            this.checkGroup();
            var expression = this.conditionService.createValueExpression();
            expression.comparsionOperator = 0;
            this.group.children.push(expression);
        }

        public getType(obj: Object) {
            var funcNameRegex = /function (.{1,})\(/;
            var results = (funcNameRegex).exec((obj).constructor.toString());
            var returnObj = (results && results.length > 1) ? results[1] : "";
            var split = returnObj.split('_');

            return split[0];
        }


        public static getDragValue(): models.TreeConfigurationItem {
            return ProcessConfigurationTree.getDecodedTreeItem(true);
        }
    }

    export class ExpressionGroupController implements IController {

        private scope: IExpressionGroupScope;
        private element: JQuery;

        constructor(
            $scope: IExpressionGroupScope,
            $compile: angular.ICompileService,
            conditionService: services.ConditionService)
        {
            $scope.model = new ExpressionGroupModel(conditionService, $compile, $scope, (<any>$scope).isReadonly);

            var self = this;
            $scope.$watch('group', newValue => {
                if (!newValue) return;
                $scope.model.setGroup(<Wars.Domain.Model.Conditions.GroupExpression>(newValue), self.element);
            });
        }

        public setElement(element: JQuery): void {
            this.element = element;
        }
    }
}

warsApp.registerDirective('ExpressionGroup', ['conditionService', '$compile']);